(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/api-proxy/assets/javascripts/proxy-handler.js') >= 0) return;  svs.modules.push('/components/lb-utils/api-proxy/assets/javascripts/proxy-handler.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const trinidad = svs.isServer ? require('@svenskaspelab/trinidad-core').core : svs.core;
const {
  match
} = svs.isServer ? require('./path-to-regexp.es6') : svs.components.lbUtils.apiProxy.pathToRegexp;
const {
  HTTP_METHOD
} = svs.isServer ? require('./constants.es6') : svs.components.lbUtils.apiProxy.constants;
const getLogger = svs.isServer ? trinidad.logger : svs.core.log.getLogger;
const logger = getLogger('lb-utils:api-proxy:proxy-handler');

const coercePath = path => path
.replace(/([:a-zA-Z_-]*)(\*{1,2})+/g, (_, parameterName, wildcard) => {
  const expression = '(.*)';
  if (!parameterName) {
    return expression;
  }
  return parameterName.startsWith(':') ? "".concat(parameterName).concat(wildcard) : "".concat(parameterName).concat(expression);
})
.replace(/([^/])(:)(?=(?:\d+|\(\.\*\))(?=\/|$))/, '$1\\$2')
.replace(/^([^/]+)(:)(?=\/\/)/, '$1\\$2');
class ApiProxyHandler {
  constructor(method, predicate, resolver) {
    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    this.method = method;
    this.predicate = predicate;
    this.resolver = resolver;
    this.options = options;
    this.matcher = match(this.createMatchPredicate(predicate));
  }

  createMatchPredicate(predicate) {
    const normalizedPath = this.normalizePath(predicate);
    return typeof normalizedPath === 'string' ? coercePath(normalizedPath) : normalizedPath;
  }

  cleanUrl(path) {
    if (path.endsWith('?')) {
      return path;
    }

    return path.replace(/[?|#].*$/g, '');
  }

  normalizePath(path) {
    if (path instanceof RegExp) {
      return path;
    }
    return this.cleanUrl(path);
  }

  evaluateProduct(params) {
    var _this$options$config, _this$options;
    const {
      allowedProducts
    } = (_this$options$config = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.config) !== null && _this$options$config !== void 0 ? _this$options$config : {};
    return !allowedProducts || params && allowedProducts.includes(params.product);
  }

  async evaluateToggles() {
    var _this$options$config2, _this$options2;
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const {
      shouldUseCloud: shouldUseCloudFn
    } = (_this$options$config2 = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.config) !== null && _this$options$config2 !== void 0 ? _this$options$config2 : {};
    let shouldUseCloud = false;
    try {
      var _await$shouldUseCloud;
      shouldUseCloud = (_await$shouldUseCloud = await shouldUseCloudFn(options)) !== null && _await$shouldUseCloud !== void 0 ? _await$shouldUseCloud : false;
    } catch (error) {
      logger.error('Error evaluating feature toggle:', error);
    }
    return shouldUseCloud;
  }

  async match(url) {
    var _this$options3;
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const result = this.matcher(url);
    if (result === false) {
      return {
        matches: false,
        params: undefined
      };
    }
    const params = result.params;
    const validProduct = this.evaluateProduct(params);
    if (!validProduct) {
      return {
        matches: false,
        params
      };
    }
    let paramTypesAreValid = true;
    if (params && (_this$options3 = this.options) !== null && _this$options3 !== void 0 && (_this$options3 = _this$options3.config) !== null && _this$options3 !== void 0 && _this$options3.validate) {
      try {
        paramTypesAreValid = Boolean(this.options.config.validate(params));
      } catch (error) {
        logger.error('Error validating handler params:', error);
        paramTypesAreValid = false;
      }
    }
    if (!paramTypesAreValid) {
      return {
        matches: false,
        params
      };
    }
    const shouldUseCloud = await this.evaluateToggles(options);
    return {
      matches: Boolean(shouldUseCloud),
      params
    };
  }

  async execute(_ref) {
    var _this$options4, _this$options5, _options$credentials;
    let {
      url,
      params,
      options,
      transport
    } = _ref;
    const cloudEndpointTemplate = (_this$options4 = this.options) === null || _this$options4 === void 0 || (_this$options4 = _this$options4.config) === null || _this$options4 === void 0 ? void 0 : _this$options4.cloudEndpointTemplate;
    if (!cloudEndpointTemplate) {
      logger.error('cloudEndpointTemplate is not defined in handler options');
      throw new Error('cloudEndpointTemplate is not defined in handler options');
    }
    let cloudUrl = Object.entries(params).reduce((acc, _ref2) => {
      let [key, value] = _ref2;
      return acc.replace(":".concat(key), value);
    }, cloudEndpointTemplate);
    if ((_this$options5 = this.options) !== null && _this$options5 !== void 0 && (_this$options5 = _this$options5.config) !== null && _this$options5 !== void 0 && _this$options5.preserveQuery && typeof url === 'string') {
      const queryIndex = url.indexOf('?');
      if (queryIndex !== -1) {
        const fragmentIndex = url.indexOf('#', queryIndex);
        const query = fragmentIndex === -1 ? url.slice(queryIndex) : url.slice(queryIndex, fragmentIndex);
        cloudUrl = "".concat(cloudUrl).concat(query);
      }
    }
    const requestOptions = _objectSpread(_objectSpread({}, options), {}, {
      credentials: (_options$credentials = options.credentials) !== null && _options$credentials !== void 0 ? _options$credentials : 'include'
    });
    const response = await transport(cloudUrl, _objectSpread({}, requestOptions));
    return {
      response,
      cloudUrl
    };
  }
}

function createHttpHandler(method) {
  return function (predicate, resolver) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return new ApiProxyHandler(method, predicate, resolver, options);
  };
}

const http = {
  get: createHttpHandler(HTTP_METHOD.GET),
  post: createHttpHandler(HTTP_METHOD.POST),
  put: createHttpHandler(HTTP_METHOD.PUT),
  patch: createHttpHandler(HTTP_METHOD.PATCH),
  delete: createHttpHandler(HTTP_METHOD.DELETE),
  head: createHttpHandler(HTTP_METHOD.HEAD),
  options: createHttpHandler(HTTP_METHOD.OPTIONS)
};

const handlers = {
  ApiProxyHandler,
  http
};
if (svs.isServer) {
  module.exports = handlers;
} else {
  setGlobal('svs.components.lbUtils.apiProxy', handlers);
}

 })(window);